import app from 'flarum/forum/app';
/**
 * POSTs a single file to fof/upload - shared by CardLayoutEditor
 * (uploadLogo), ExhibitionFindingEditModal (uploadPhoto), ExhibitionPage
 * (uploadFindingPhoto), ToxicityEditModal (uploadSvg), and
 * CartothequeDescriptionEditor (insertImage). Each caller keeps its own
 * loading-flag/error-handling around this, since those genuinely differ
 * (some show an inline errorMessage, one shows an app.alerts toast, one
 * ignores errors silently) - only the request itself was duplicated.
 *
 * Resolves to the uploaded file's JSON:API resource object (`{type, id,
 * attributes: {url, ...}}`), or `undefined` if fof/upload's own response
 * had no `data[0]` for some reason.
 */
export default function uploadFile(file) {
  const body = new FormData();
  body.append('files[]', file);
  return app.request({
    method: 'POST',
    url: app.forum.attribute('apiUrl') + '/fof/upload',
    body
  }).then(response => response.data && response.data[0]);
}
flarum.reg.add('champis-exhibitions', 'forum/utils/uploadFile', uploadFile);